export default class SoilType {
  constructor({id = 0, name = ''} = {}) {
    this.id = id;
    this.name = name;
  }
}
